import React from 'react';
import proptypes from 'prop-types';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { useConfigService } from '@thd-nucleus/experience-context';
import { useSpecialBuy } from '../../../context/SpecialBuyProvider';
import { getPromoHeading } from '../../../utils/utils'
import { FEATURE_SWITCH_KEYS } from '../../../constants';

const { shape, string } = proptypes;

export const SeeAll = ({ category }) => {
  const { specialBuyType, specialBuyEndpoint } = useSpecialBuy();
  const isDailyDealsEnabled = useConfigService(FEATURE_SWITCH_KEYS.isDailyDealsEnabled);
  const isWeeklyDealsEnabled = useConfigService(FEATURE_SWITCH_KEYS.isWeeklyDealsEnabled);

  return (
    <div
      className="sui-justify-center sui-align-items-center sui-p-2 sui-text-info"
      // id property is required by analytics
      id={specialBuyType === 'sbotd' ? 'SBOTD' : 'SBOTW'}
      data-testid="see-all-special-buy"
    >
      <Link href={`${specialBuyEndpoint}#${category.categoryId}`} underline="hover">
        <Typography component="span" variant="body-sm">
          See All {category.name}&nbsp;
          {getPromoHeading(specialBuyType, isDailyDealsEnabled, isWeeklyDealsEnabled)}
        </Typography>
      </Link>
    </div>
  );
};

SeeAll.displayName = 'SeeAll';

SeeAll.propTypes = {
  category: shape({
    name: string.isRequired,
    categoryId: string.isRequired,
  }).isRequired
};
